import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useDialogContext } from './dialog-context-provider';
import { DialogHeaderIcon } from './dialog-header-title-icon';
import { ModalHeaderTitle, ModalHeaderTitleProps } from '../modal/modal-header-title';

export type DialogHeaderTitleProps = ModalHeaderTitleProps;

export const DialogHeaderTitle = ({
  className,
  children,
  ...props
}: DialogHeaderTitleProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-dialog__header-title');
  const { disableLegacy } = useDialogContext();
  useEffect(() => disableLegacy(), []);

  return (
    <ModalHeaderTitle {...props} className={classNames}>
      <DialogHeaderIcon />
      {children}
    </ModalHeaderTitle>
  );
};
